import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  DelegationBasicInfo,
  DelegationContactInfo,
  DelegationFileUpload,
  DelegationFormActions,
} from "../../components/forms/DelegationForm";

interface EditDelegationProps {}

const EditDelegation: React.FC<EditDelegationProps> = () => {
  const navigate = useNavigate();

  // Get ID from URL path
  const getDelegationId = () => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[pathParts.length - 1];
  };

  const id = getDelegationId();

  const [formData, setFormData] = useState({
    country: "",
    organization: "",
    fromDate: "",
    toDate: "",
    quarter: "",
    delegationName: "",
    budget: "",
    budgetSource: "",
    receivingUnit: "",
    purpose: "",
    otherPurpose: "",
    basis: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  // Mock data for editing - in real app, this would come from API
  const mockDelegationData = {
    country: "Việt Nam",
    organization: "Tổ chức 1",
    fromDate: "2022-03-28",
    toDate: "2022-04-06",
    quarter: "Q1",
    delegationName: "Đoàn 1",
    budget: "90000000",
    budgetSource: "Ngân sách khác",
    receivingUnit: "Phòng Kế hoạch khoa học",
    purpose: "Tham gia chương trình đào tạo",
    otherPurpose: "",
    basis: "Quyết định số 123/QĐ-BKHCN",
    notes: "fbf",
    attachedFiles: [] as File[],
  };

  useEffect(() => {
    // Load delegation data for editing
    if (id) {
      // In real app, fetch data from API based on id
      setFormData(mockDelegationData);
    }
  }, [id]);

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Updating delegation data:", formData);
    // TODO: Implement update functionality
    // After successful update, navigate back to delegation list
    navigate("/incoming-delegations");
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Sửa Đoàn vào">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">Sửa Đoàn vào</h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <DelegationBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <DelegationContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <DelegationFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <DelegationFormActions onSave={handleSave} onCancel={handleCancel} />
      </div>
    </PageShell>
  );
};

export default EditDelegation;
